import { baseTheme } from './SwitchBaseTheme.css';

/*******************
 * Component Theme
 *******************/

const SwitchStableTheme = {
  baseTheme
};

/*******************
 * Exports
 *******************/

export { SwitchStableTheme };
